import { cn } from '@april9au/react-common/utils';

import type { IconName } from '@/components/ui/icon';
import { Icon } from '@/components/ui/icon';

import { SectionHeader } from './section-header';

export type ValueItem = {
  title: string;
  description?: string;
  icon?: IconName;
};

/** "Why choose us" style benefits list. Reusable on the homepage, About page, or service pages. */
export function ValueProposition({
  id,
  eyebrow,
  heading,
  description,
  items,
  align = 'left',
  className,
}: {
  id?: string;
  eyebrow?: string;
  heading: string;
  description?: string;
  items: Array<ValueItem>;
  align?: 'left' | 'center';
  className?: string;
}) {
  return (
    <section id={id} className={cn('section', className)}>
      <div className="container">
        <SectionHeader eyebrow={eyebrow} heading={heading} description={description} align={align} className="mb-12" />

        <div className="value-list sm:grid sm:grid-cols-2 sm:gap-x-12 sm:gap-y-6 lg:grid-cols-3">
          {items.map((item) => (
            <div key={item.title} className="value-item">
              <Icon name={item.icon ?? 'heroicons/check-circle-micro'} className="value-item__icon" />
              <div>
                <h3 className={item.description ? 'text-h3 mb-1' : 'text-base font-medium text-foreground'}>
                  {item.title}
                </h3>
                {item.description ? <p className="text-body">{item.description}</p> : null}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
